module.exports = __webpack_public_path__ + "img/longarrow-left-white.6cd0a236.svg";